var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.6 1.2 61.2 61.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fh",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8862c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 4 L29 35",
    stroke: "#7a5418",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 4 L29 35",
    stroke: "url(#fh)",
    strokeWidth: 3.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33 L25.5 38.5",
    stroke: "#8e2f1c",
    strokeWidth: 5.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 35.1 L28.7 47.3",
    stroke: "#8a8a8a",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9c9c9c",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3 35.4 Q10.8 43.1 2.9 49.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0 39.3 Q14.5 47.0 6.6 53.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6 43.1 Q18.2 50.8 10.2 56.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3 47.0 Q21.9 54.7 13.9 60.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/farm.967d1e8fa2d60b5046449ab7b1c5c6bb.svg";
export { ForwardRef as ReactComponent };